export default __webpack_public_path__ + "static/media/relaxed-goose.eb071648.png";